
        var result = require("!!../../../../node_modules/css-loader/index.js!./file-detail.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/file-detail/file-detail.component.css
// module id = 612
// module chunks = 0